import { render, staticRenderFns } from "./OpinionRealTime.vue?vue&type=template&id=a992f4e0"
import script from "./OpinionRealTime.vue?vue&type=script&lang=js"
export * from "./OpinionRealTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports